import { KeyValue } from '@angular/common';
import {
    Directive,
    HostListener,
    Input
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';

@Directive({
    selector: '[smtSelect]'
})
export class SearchSelectDirective {
    @Input() control: AbstractControl<any, any> | undefined;
    @Input() selectInput: MatInput | undefined;
    @Input() selectedOptions: KeyValue<string, string>[];
    @Input() selectAutocomplete: MatAutocompleteTrigger | undefined;

    // Focus listener
    @HostListener('focus', ['$event'])
    onFocusIn(_event: FocusEvent): void {
        const value = this.control.value;
        if(value === null) {
            this.control.setValue('');
        } else if(this.control.pristine) {
            this.control.setValue(value);
        }
    }

    // Focusout listener
    @HostListener('focusout', ['$event'])
    onFocusOut(event: FocusEvent): void {
        // Si tiene seleccionado algún valor, limpiar el input si no se ha seleccionado otro valor
        if (this.selectedOptions?.length > 0 && this.selectInput?.value) {
            this.selectInput.value = '';
        }

        // Para cerrar el desplegable si se ha quedado abierto cuando no debe
        const nextFocused = event.relatedTarget as HTMLElement;
        const panel = document.querySelector('.mat-autocomplete-panel');
        const hasToClose = !(panel && panel.contains(nextFocused));
        if(hasToClose) {
            this.selectAutocomplete.closePanel();
        }
    }
}